import { Component, Input, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-impersonate-tutorial',
  templateUrl: './impersonate-tutorial.component.html',
  styleUrls: ['./impersonate-tutorial.component.scss']
})
export class ImpersonateTutorialComponent implements OnInit {
  @Input() impersonateCode!: string;
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  constructor() { }

  ngOnInit(): void {
  }

  copyCode() {
    navigator.clipboard.writeText(
      `
      ${this.impersonateCode};
      location.reload();
      `
    );
    this.Toast.fire({
      icon: 'success',
      text: 'کپی شد.'
    });
  }
}
